import axios from "./_axios";
import { API } from "./apiEndPoints";

/**
 * Get secure app configuration from backend
 * Requires authentication
 */
export const getAppConfig = async () => {
  const result = await axios()({
    method: "get",
    url: API.APP_CONFIG,
  });
  return result;
};
